import { useContext } from "react";
import { ServicesContext } from "../servicesContext";
export const useServices = () => {
    const services = useContext(ServicesContext);
    if (services === undefined)
        throw new Error("useServices should be used inside ServicesProvider");
    return services;
};
